<template>
	<div id='banner'>
		<div class="banner">
			<div class="bannerImg1" :height="bannerH +'px'">
				<transition-group tag="div">
					<span v-for="(v,i) in datalist" :key="i" :style="{opacity:(i+1)==n?'1':'0'}"
						class="active">
						<img v-bind:src="v.imageUrl" class="bannerImg1">
					</span>
				</transition-group>
			</div>
<!-- 			<ul class="bannerBtn clear-fix">
				<li v-for="num in 1">
					<a href="javascript:;" :style="{background:num==n?'#fff':''}" @click='change(num)'
						class='aBtn'></a>
				</li>
			</ul> -->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				bannerH: 200,
				datalist: [],
				n: 1, // 图片的index。
				bFlag: true, // 锁定
				timer1: '',
				// 这是bFlag定时器的数据
				timer2: '', // 这是自动播放（next（））定时器的数据
				timer3: '', // 这是打开浏览器时，初始运动定时器的数据
			};
		},
		created() {
			
		},
		mounted() {
			this.setBannerH();
			this.getData1();
			window.addEventListener('resize', () => {
				this.setBannerH()
			}, false);
			this.timer3 = setTimeout(this.next, 3000);
		},
		methods: {
			getData1() {
				this.axios.get('/api/irpi/home/carousel/findBanner').then(res=>{
					this.datalist = res.data.data
				})
			},
			// 转换为带省略号的短标题名
			getShortTitle(cTitleString, ndataMaxLen) {
				if (cTitleString.length > ndataMaxLen) {
					return cTitleString.substr(0, ndataMaxLen) + '...';
				} else return cTitleString;
			},
			setBannerH() {
				this.bannerH = document.body.clientWidth / 5.5
				if (window.innerWidth < 768) {
					this.bannerH = document.body.clientWidth / 3.2
				}
			},
			next() { // 下一张　　　 // 为了避免连续点击。让bFlag运动结束后再变为true。　　　　　　　　　　　　　　
				if (this.bFlag) {
					this.bFlag = false;
					this.clearT(); // 运动之前，清除所有定时器。
					this.n = this.n + 1 == 2 ? 1 : this.n + 1; // 下一张，如果是第4张，就返回第一张。 // 调用timeout函数，延迟进入下一次轮播，以便可以点击切换。
					this.timeout();
				}
			},
			clearT() { // 清除所有定时器　　　　　　　　　　　　　　　
				clearTimeout(this.timer1);
				clearTimeout(this.timer2);
				clearTimeout(this.timer3);
			},
			timeout() {
				// 运动结束后设置bFlag为true，并且3秒后调用next，进行下一次运动。
				// 运动时间是1s。
				this.timer2 = setTimeout(() => {
					this.bFlag = true
				}, 1400);
				this.timer1 = setTimeout(() => {
					this.next()
				}, 5000);
			},
			change(num) { // 点击按钮，切换到对应图片，需要获取index。
				if (this.bFlag) {
					this.bFlag = false;
					this.clearT();
					this.n = num; // 将显示图片变为选中的那一张。　　　　
					this.timeout()
				}
			}
		},
	}
</script>

<style scoped>
	@-webkit-keyframes fadeIn {
		0% {
			opacity: 0;
			/*初始状态 透明度为0*/
		}

		50% {
			opacity: 0;
			/*中间状态 透明度为0*/
		}

		100% {
			opacity: 1;
			/*结尾状态 透明度为1*/
		}
	}

	* {
		list-style: none;
	}

	#banner {
		width: 100%;
		max-width: 100%;
		min-height:480px;
		background-color: #eee;
	}

	.bannerTime {
		font-size: 14px;
		color: white;
		line-height: 40px;
		position: absolute;
		right: 5px;
	}

	.banner {
		position: relative;
	}

	.bannerImg1 {
		position: relative;
		max-width: 100%;
		width:1920px;
		height:480px;
	}

	.bannerImg1 span {
		position: absolute;
		top: 0;
		left: 0;
	}

	.bannerImg1 span.active {
		transition: all 1s;
	}

	.bannerBtn {
		width: 220px;
		position: absolute;
		left: 50%;
		margin-left:-115px;
		bottom: 2px;
		text-align: center;
	}

	.bannerBtn li {
		margin: 0 13px;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		float: left;
		background: rgba(255, 255, 255, .4);
	}

	.bannerBtn li a {
		display: block;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		margin: 3px;
	}

	.bannerBtn li a.aBtn {
		transition: all .6s ease;
	}
</style>
